export function arraySort(array, field) {
  if (!array) return [];
  return array.sort((a, b) => {
    if (a[field] < b[field]) return -1;
    else if (a[field] > b[field]) return 1;
    else return 0;
  });
}
